import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IntergrationDtoKeyEnum } from '@zaoblako/shared/modules/integration/enums/intergration-dto-key.enum';
import { entityLikeSchemaUuid } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';

import * as yup from 'yup';

/** 1C ERP plugin description create and update APIs request body - DTO signature */
export interface Plugin1cFormInterface {
  /** Plugin file descriptor */
  file: OnlyIdRequiredInterface<FileFindInterface>;
  /** Additional comment containing information about changes to the extension */
  changelog?: string;
}

/** 1C ERP plugin description create and update APIs request body - DTO schema */
export const Plugin1cFormDto = SerdeDtoClass.create<Plugin1cFormInterface>(IntergrationDtoKeyEnum.PLUGIN_1C_FORM_DTO, {
  file: {
    label: 'Файл расширения',
    serializer: entityLikeSchemaUuid,
  },
  changelog: {
    optional: true,
    sortable: true,
    label: 'История изменений',
    serializer: yup.string(),
  },
});
